import { useState, useCallback } from 'react';
import { payAmigoClient } from '../api/payamigo';

interface UsePayAmigoCoinsResult {
  coins: Array<{ key: string; value: string }>;
  isLoading: boolean;
  error: string | null;
  fetchCoins: () => Promise<void>;
}

export const usePayAmigoCoins = (): UsePayAmigoCoinsResult => {
  const [coins, setCoins] = useState<Array<{ key: string; value: string }>>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchCoins = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await payAmigoClient.getAvailableCoins();
      const formattedCoins = response.map((coin) => ({
        key: coin,
        value: coin,
      }));
      setCoins(formattedCoins);
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to fetch coins';
      setError(errorMessage);
      console.error('Fetch coins error:', err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    coins,
    isLoading,
    error,
    fetchCoins,
  };
};

